import Vouchers from "./vouchers";
import AddVoucher from "./add-voucher";
import EditVoucher from "./edit-voucher";
import ViewVoucher from "./view-voucher";
import SearchVoucher from "./search-voucher";

export default {Vouchers, AddVoucher, EditVoucher, ViewVoucher, SearchVoucher};